<template>
    <div class="dropdown" @mouseover="isOpen = true" @mouseleave="isOpen = false">  
        <a href="/shop/" class="button-dropdown el" v-if="!isOpen">
                {{ title }}
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path d="M310.6 246.6l-127.1 128C176.4 380.9 168.2 384 160 384s-16.38-3.125-22.63-9.375l-127.1-128C.2244 237.5-2.516 223.7 2.438 211.8S19.07 192 32 192h255.1c12.94 0 24.62 7.781 29.58 19.75S319.8 237.5 310.6 246.6z"/></svg>
        </a>
        <a href="/shop/" class="button-dropdown el" v-if="isOpen">
                {{ title }}
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path d="M9.39 265.4l127.1-128C143.6 131.1 151.8 128 160 128s16.38 3.125 22.63 9.375l127.1 128c9.156 9.156 11.9 22.91 6.943 34.88S300.9 320 287.1 320H32.01c-12.94 0-24.62-7.781-29.58-19.75S.2333 274.5 9.39 265.4z"/></svg>
        </a>
        <transition name="slide-up" appear>
            <div class="sidebar-drop" v-if="isOpen">
                <div class="side-cont">
                <div class="menu-col"> 
                    <div class="menu-item2 cel">
                        <a href="/epipla-esoterikou-xorou/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" /><img class="myico" src="/wp-content/uploads/2025/11/esoterikou1.png" alt="ΕΠΙΠΛΑ"/><strong>ΕΠΙΠΛΑ ΕΣΩΤΕΡΙΚΟΥ ΧΩΡΟΥ</strong></a>
                    </div> 
                    <div class="menu-item1">
                        <a href="/epipla-tileorasis/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" />ΕΠΙΠΛΑ ΤΗΛΕΟΡΑΣΗΣ</a>
                    </div>
                    <div class="menu-item1">
                        <a href="/kanapedes/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" />ΚΑΝΑΠΕΔΕΣ</a>
                    </div>
                    <div class="menu-item1">
                        <a href="/karekles/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" />ΚΑΡΕΚΛΕΣ</a>
                    </div>
                    <div class="menu-item1">
                        <a href="/komodina/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" />ΚΟΜΟΔΙΝΑ</a>
                    </div>
                    <div class="menu-item1">
                        <a href="/krevatia/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" />ΚΡΕΒΑΤΙΑ</a>
                    </div>
                    <div class="menu-item1">
                        <a href="/ntoulapes-rouxon/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" />ΝΤΟΥΛΑΠΕΣ</a>
                    </div>
                    <div class="menu-item1">
                        <a href="/syntheseis-saloniou/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" />ΣΥΝΘΕΣΕΙΣ ΣΑΛΟΝΙΟΥ</a>
                    </div>
                    <div class="menu-item1">
                        <a href="/trapezakia-saloniou/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" />ΤΡΑΠΕΖΑΚΙΑ ΣΑΛΟΝΙΟΥ</a>
                    </div>
                    <div class="menu-item1">
                        <a href="/papoutsothikes-ntoulapia/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" />ΠΑΠΟΥΤΣΟΘΗΚΕΣ ΚΑΙ ΝΤΟΥΛΑΠΙΑ</a>
                    </div>
                    <div class="menu-item1">
                        <a href="/trapezaria/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" />ΤΡΑΠΕΖΑΡΙΑ</a>
                    </div>
                    <div class="menu-item1">
                        <a href="/paidiko-domatio/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" />ΠΑΙΔΙΚΟ ΔΩΜΑΤΙΟ</a>
                    </div>
                    <div class="menu-item1">
                        <a href="/polythrones-krevati/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" />ΠΟΛΥΘΡΟΝΕΣ - ΚΡΕΒΑΤΙ</a>
                    </div>
                    <div class="menu-item1">
                        <a href="/polythrones-saloniou-epipla-saloniou-3/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" />ΠΟΛΥΘΡΟΝΕΣ ΣΑΛΟΝΙΟΥ</a>
                    </div>
                    <div class="menu-item1">
                        <a href="/trapezakia-voithitika/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" />ΤΡΑΠΕΖΑΚΙΑ ΒΟΗΘΗΤΙΚΑ</a>
                    </div>                  
                    <div class="menu-item2 let">
                        <a href="/paixnidia/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" /><img class="myico" src="/wp-content/uploads/2025/11/paixnidia.png" alt="ΕΠΙΠΛΑ"/><strong>ΠΑΙΧΝΙΔΙΑ</strong></a>
                    </div> 
                    <div class="menu-item1">
                        <a href="/lego/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" />LEGO</a>
                    </div>
                    <div class="menu-item1">
                        <a href="/funko-pop/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" />FUNKO POP</a>
                    </div>
                    <div class="menu-item1">
                        <a href="/vrefika-paixnidia/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" />ΒΡΕΦΙΚΑ</a>
                    </div>
                    <div class="menu-item1">
                        <a href="/epitrapezia-pazl/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" />ΕΠΙΤΡΑΠΕΖΙΑ-ΠΑΖΛ</a>
                    </div>
                    <div class="menu-item1">
                        <a href="/ergaleia/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" />ΕΡΓΑΛΕΙΑ</a>
                    </div>

                    <div class="menu-item1">
                        <a href="/koukles-axesouar/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" />ΚΟΥΚΛΕΣ ΑΞΕΣΟΥΑΡ</a>
                    </div>
                    <div class="menu-item1">
                        <a href="/opla-spathia/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" />ΟΠΛΑ ΣΠΑΘΙΑ</a>
                    </div>
                    <div class="menu-item1">
                        <a href="/systimata-paidikis-charas/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" />ΣΥΣΤΗΜΑΤΑ ΠΑΙΔΙΚΗΣ ΧΑΡΑΣ</a>
                    </div>
                    <div class="menu-item1">
                        <a href="/figoures-drasis/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" />ΦΙΓΟΥΡΕΣ ΔΡΑΣΗΣ</a>
                    </div>
                    

                    <div class="menu-item2 let">
                        <a href="/oikiakos-exoplismos/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" /><img class="myico" src="/wp-content/uploads/2025/11/oikiaka.png" alt="ΕΠΙΠΛΑ"/><strong>ΟΙΚΙΑΚΟΣ ΕΞΟΠΛΙΣΜΟΣ</strong></a>
                    </div> 
                    <div class="menu-item1">
                        <a href="/ntoulapes/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right"/>ΝΤΟΥΛΑΠΕΣ</a>
                    </div>
                    <div class="menu-item1">
                        <a href="/baoula/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" /><strong>ΜΠΑΟΥΛΑ</strong></a>
                    </div> 
                    <!-- -->

                    <div style="height:50px !important"></div>          
                </div>
                <div class="menu-col1 el">
                    <div class="menu-item2 let">
                        <a href="/epipla-exoterikou-xorou/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" /><img class="myico" src="/wp-content/uploads/2025/11/exoterikou.png" alt="ΕΠΙΠΛΑ"><strong>ΕΠΙΠΛΑ ΕΞΩΤΕΡΙΚΟΥ ΧΩΡΟΥ</strong></a>
                    </div> 
                    <div class="menu-item1">
                        <a href="/set-trapezaria-kipou/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" />ΣΕΤ ΤΡΑΠΕΖΑΡΙΑ ΚΗΠΟΥ</a>
                    </div>
                    <div class="menu-item1">
                        <a href="/salonia-kipou/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" />ΣΑΛΟΝΙΑ ΚΗΠΟΥ</a>
                    </div>
                    <div class="menu-item1">
                        <a href="/karekles-polithrones-kipou/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right"/>ΚΑΡΕΚΛΕΣ & ΠΟΛΥΘΡΟΝΕΣ ΚΗΠΟΥ</a>
                    </div>
                    <div class="menu-item1">
                        <a href="/trapezia-fagitou-kipou/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right"/>ΤΡΑΠΕΖΙΑ ΦΑΓΗΤΟΥ ΚΗΠΟΥ</a>
                    </div>
                    <div class="menu-item1">
                        <a href="/skabo-kipou/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" /><strong>ΣΚΑΜΠΟ ΚΗΠΟΥ</strong></a>
                    </div> 
                    <div class="menu-item1">
                        <a href="/skabo-bar/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" /><strong>ΣΚΑΜΠΟ ΜΠΑΡ</strong></a>
                    </div> 
                    <div class="menu-item1">
                        <a href="/pagkakia-kipou/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" /><strong>ΠΑΓΚΑΚΙΑ ΚΗΠΟΥ</strong></a>
                    </div> 
                    <div class="menu-item1">
                        <a href="/obreles-vaseis-omprelon/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" /><strong>ΟΜΠΡΕΛΕΣ & ΒΑΣΕΙΣ ΟΜΠΡΕΛΩΝ</strong></a>
                    </div> 
                    <div class="menu-item1">
                        <a href="/kounies-kipou/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" /><strong>ΚΟΥΝΙΕΣ ΚΗΠΟΥ</strong></a>
                    </div> 
                    <div class="menu-item1">
                        <a href="/xaplostres-karekles-paralias/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" /><strong>ΞΑΠΛΩΣΤΡΕΣ & ΚΑΡΕΚΛΕΣ ΠΑΡΑΛΙΑΣ</strong></a>
                    </div> 
                    <div class="menu-item1">
                        <a href="/ntoulapes-exoterikou-chorou/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" /><strong>ΝΤΟΥΛΑΠΕΣ ΕΞΩΤΕΡΙΚΟΥ ΧΩΡΟΥ</strong></a>
                    </div> 
                    <div class="menu-item1">
                        <a href="/epipla-catering-sinedriou/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" /><strong>ΕΠΙΠΛΑ CATERING - ΣΥΝΕΔΡΙΟΥ</strong></a>
                    </div> 

 <div class="menu-item2 cel">
                        <a href="/diakosmisi/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" /><img class="myico" src="/wp-content/uploads/2025/11/decoration.png" alt="ΕΠΙΠΛΑ"/><strong>ΔΙΑΚΟΣΜΗΣΗ</strong></a>
                    </div> 
                    <div class="menu-item1">
                        <a href="/pinakes/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" />ΠΙΝΑΚΕΣ</a>
                    </div>
                    <div class="menu-item1">
                        <a href="/kathreptes/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" />ΚΑΘΡΕΠΤΕΣ</a>
                    </div>
                    <div class="menu-item1">
                        <a href="/diakosmitika/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" />ΔΙΑΚΟΣΜΗΤΙΚΑ</a>
                    </div>
                    <div class="menu-item1">
                        <a href="/technita-fyta/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" />ΤΕΧΝΗΤΑ ΦΥΤΑ</a>
                    </div>
                    <div class="menu-item1">
                        <a href="/rologia/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" />ΡΟΛΟΓΙΑ</a>
                    </div>
                    <div class="menu-item1">
                        <a href="/chalia/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" />ΧΑΛΙΑ</a>
                    </div>

                    <!-- 3 -->

                    <!-- -->
                    
                </div>

                <div class="menu-col1">
                    <div class="menu-item2 per">
                        <a href="/epipla-grafeiou/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" /><img class="myico" src="/wp-content/uploads/2025/11/grafeio.png" alt="ΕΠΙΠΛΑ"><strong>ΕΠΙΠΛΑ ΓΡΑΦΕΙΟΥ</strong></a>
                    </div> 
                    
                    <div class="menu-item1">
                        <a href="/karekles-grafiou/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" /><strong>ΚΑΡΕΚΛΕΣ ΓΡΑΦΕΙΟΥ</strong></a>
                    </div> 
                     <div class="menu-item1">
                        <a href="/karekles-grafeiou-episkepti/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" /><strong>ΚΑΡΕΚΛΕΣ ΓΡΑΦΕΙΟΥ ΕΠΙΣΚΕΠΤΗ</strong></a>
                    </div>                     
                    <div class="menu-item1">
                        <a href="/vivliothikes-grafeiou/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" /><strong>ΒΙΒΛΙΟΘΗΚΕΣ ΓΡΑΦΕΙΟΥ</strong></a>
                    </div> 
                    <div class="menu-item1">
                        <a href="/syrtarieres-grafeiou/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" /><strong>ΣΥΡΤΑΡΙΕΡΕΣ ΓΡΑΦΕΙΟΥ</strong></a>
                    </div> 
                    <div class="menu-item1">
                        <a href="/ntoulapes-grafeiou/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" /><strong>ΝΤΟΥΛΑΠΕΣ ΓΡΑΦΕΙΟΥ</strong></a>
                    </div> 
                    <div class="menu-item1">
                        <a href="/trapezakia-grafeiou/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" /><strong>ΤΡΑΠΕΖΑΚΙΑ ΓΡΑΦΕΙΟΥ</strong></a>
                    </div> 
                    <div class="menu-item1">
                        <a href="/trapezia-synedriou/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" /><strong>ΤΡΑΠΕΖΙΑ ΣΥΝΕΔΡΙΟΥ</strong></a>
                    </div> 
                    <div class="menu-item1">
                        <a href="/reception-grafeiou/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" /><strong>RECEPTION ΓΡΑΦΕΙΟΥ</strong></a>
                    </div> 
                    <div class="menu-item1">
                        <a href="/axesouar/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" /><strong>ΑΞΕΣΟΥΑΡ</strong></a>
                    </div> 
                    <div class="menu-item1">
                        <a href="/polythrones-grafeiou/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" /><strong>ΠΟΛΥΘΡΟΝΕΣ ΓΡΑΦΕΙΟΥ</strong></a>
                    </div> 

                    <div class="menu-item2 per">
                        <a href="/boho-chic/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" /><img class="myico" src="/wp-content/uploads/2025/11/boho.png" alt="ΕΠΙΠΛΑ"/><strong>BOHO CHIC</strong></a>
                    </div> 
                    <div class="menu-item1">
                        <a href="/diakosmitika-boho-chic/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" /><strong>ΔΙΑΚΟΣΜΗΤΙΚΑ</strong></a>
                    </div>
                    <div class="menu-item1">
                        <a href="/eidi-ex-chorou-paralias/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" /><strong>ΕΙΔΗ ΕΞ. ΧΩΡΟΥ/ΠΑΡΑΛΙΑΣ</strong></a>
                    </div>
                    <div class="menu-item1">
                        <a href="/kanapedes-pagkakia/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" /><strong>ΚΑΝΑΠΕΔΕΣ & ΠΑΓΚΑΚΙΑ</strong></a>
                    </div>
                    <div class="menu-item1">
                        <a href="/karekles-kai-polythrones/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" /><strong>ΚΑΡΕΚΛΕΣ ΚΑΙ ΠΟΛΥΘΡΟΝΕΣ</strong></a>
                    </div>
                    <div class="menu-item1">
                        <a href="/loipa-eidi-epiplosis/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" /><strong>ΛΟΙΠΑ ΕΙΔΗ ΕΠΙΠΛΩΣΗΣ</strong></a>
                    </div>
                    <div class="menu-item1">
                        <a href="/skabo-boho-chic/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" /><strong>ΣΚΑΜΠΟ</strong></a>
                    </div>
                    <div class="menu-item1">
                        <a href="/trapezakia-saloniou-boho-chic/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" /><strong>ΤΡΑΠΕΖΑΚΙΑ ΣΑΛΟΝΙΟΥ</strong></a>
                    </div>
                    <div class="menu-item1">
                        <a href="/trapezia-fagitou/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" /><strong>ΤΡΑΠΕΖΙΑ ΦΑΓΗΤΟΥ</strong></a>
                    </div>
                    <div class="menu-item1">
                        <a href="/fotistika/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" /><strong>ΦΩΤΙΣΤΙΚΑ</strong></a>
                    </div>
                                      
                    <!-- second menu -->
                
                    
        
                    <!-- second menu -->

                </div>
                <div class="menu-col1 menu-last">
                    
                    <!---->
                    
                     <div class="menu-item2 per">
                        <a href="/vivlia/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" /><img class="myico" src="/wp-content/uploads/2025/11/vivlia.png" alt="ΕΠΙΠΛΑ"/><strong>ΒΙΒΛΙΑ</strong></a>
                    </div> 
                    <div class="menu-item1">
                        <a href="/vivlia-gia-enilikes/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" /><strong>ΒΙΒΛΙΑ ΓΙΑ ΕΝΗΛΙΚΕΣ</strong></a>
                    </div>
                    <div class="menu-item1">
                        <a href="/vivlia-gia-mora/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" /><strong>ΒΙΒΛΙΑ ΓΙΑ ΜΩΡΑ</strong></a>
                    </div>
                    <div class="menu-item1">
                        <a href="/vivlia-gnoseon/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" /><strong>ΒΙΒΛΙΑ ΓΝΩΣΕΩΝ</strong></a>
                    </div>
                    
                    <div class="menu-item1">
                        <a href="/efivika-vivlia/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" /><strong>ΕΦΗΒΙΚΑ ΒΙΒΛΙΑ</strong></a>
                    </div>
                    <div class="menu-item1">
                        <a href="/paidiki-logotechnia/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" /><strong>ΠΑΙΔΙΚΗ ΛΟΓΟΤΕΧΝΙΑ</strong></a>
                    </div>
                    <div class="menu-item1">
                        <a href="/chari-poter/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" /><strong>ΧΑΡΙ ΠΟΤΕΡ</strong></a>
                    </div>
                    <div class="menu-item1">
                        <a href="/dog-man/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" /><strong>DOG MAN</strong></a>
                    </div>
                    <div class="menu-item1">
                        <a href="/kapetan-vrakas/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" /><strong>ΚΑΠΕΤΑΝ ΒΡΑΚΑΣ</strong></a>
                    </div>
                    <div class="menu-item1">
                        <a href="/iraklis-pouaro/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" /><strong>ΗΡΑΚΛΗΣ ΠΟΥΑΡΟ</strong></a>
                    </div>
                    <div class="menu-item1">
                        <a href="/enola-cholms/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" /><strong>ΕΝΟΛΑ ΧΟΛΜΣ</strong></a>
                    </div>
                                  <!-- -->
                    <div class="menu-item2 per">
                        <a href="/fotismos/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" /><img class="myico rot" src="/wp-content/uploads/2025/11/fotismos.png" alt="ΕΠΙΠΛΑ"><strong>ΦΩΤΙΣΜΟΣ</strong></a>
                    </div> 
                    <div class="menu-item1">
                        <a href="/orofis/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" /><strong>ΟΡΟΦΗΣ</strong></a>
                    </div>
                    <div class="menu-item1">
                        <a href="/epitrapezia-fotismos/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" /><strong>ΕΠΙΤΡΑΠΕΖΙΑ</strong></a>
                    </div>
                    <div class="menu-item1">
                        <a href="/dapedou/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" /><strong>ΔΑΠΕΔΟΥ</strong></a>
                    </div>
                    <div class="menu-item1">
                        <a href="/aplikes/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" /><strong>ΑΠΛΙΚΕΣ</strong></a>
                    </div>
                     
                </div>
                
                
                
            </div>
            
            </div>
            
        </transition>
        <!--<transition name="slide-up" appear>
            <div class="sidebar-drop" v-if="isOpen">
                <div class="side-cont">
                <div class="menu-col"> 
                    <div class="menu-item2 cel">
                        <a href="/celebrate-freshness/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" /><strong>CELEBRATE FRESHNESS</strong></a>
                    </div> 
                    <div class="menu-item1">
                        <a href="/collagen-chews/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" />COLLAGEN CHEWS</a>
                    </div>
                    <div class="menu-item1">
                        <a href="/happy-yak/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" />HAPPY YAK</a>
                    </div>
                    <div class="menu-item1">
                        <a href="/olive-woods/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" />OLIVE WOODS</a>
                    </div>
                    
                    <div class="menu-item1">
                        <a href="/snack-n-bark/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" />SNACK N BARK</a>
                    </div>
                    <div class="menu-item1">
                        <a href="/super-premium-snacks/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" />SUPER PREMIUM SNACKS</a>
                    </div>
                    <div class="menu-item1">
                        <a href="/the-barkers/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" />THE BARKERS</a>
                    </div>
                    <div class="menu-item1">
                        <a href="/wild-antler/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" />WILD ANTLER</a>
                    </div>
                    <div class="menu-item1">
                        <a href="/ladi-solomou/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" />ΛΑΔΙ ΣΟΛΩΜΟΥ</a>
                    </div>                 

                </div>
                <div class="menu-col1 el">
                    <div class="menu-item2 let">
                        <a href="/europremium/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" /><strong>EUROPREMIUM</strong></a>
                    </div> 
                    <div class="menu-item1">
                        <a href="/dry/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" />DRY</a>
                    </div>
                    <div class="menu-item1">
                        <a href="/snacks/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" />SNACKS</a>
                    </div>
                    <div class="menu-item2 marg">
                        <a href="/aatu/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" /><strong>AATU</strong></a>
                    </div> 
                    <div class="menu-item1">
                        <a href="/aatu-cat/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" />AATU CAT</a>
                    </div>
                    <div class="menu-item1">
                        <a href="/aatu-dog/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" />AATU DOG</a>
                    </div>
                     <div class="menu-item2 marg">
                        <a href="/shop/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" /><strong>ΠΑΙΧΝΙΔΙΑ</strong></a>
                    </div> 
                    <div class="menu-item1">
                        <a href="/nylabone/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" /><strong>NYLABONE</strong></a>
                    </div> 
                    <div class="menu-item1">
                        <a href="/pawise/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" /><strong>PAWISE</strong></a>
                    </div> 
                </div>
                <div class="menu-col1 menu-last en">
                    <div class="menu-item2 per">
                        <a href="/shop"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" /><strong>ΠΕΡΙΣΣΟΤΕΡΑ ΠΡΟΪΟΝΤΑ</strong></a>
                    </div> 
                    <div class="menu-item1">
                        <a href="/ambrosia/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" /><strong>AMBROSIA</strong></a>
                    </div> 
                     <div class="menu-item1">
                        <a href="/barking-heads-meowing-heads/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" /><strong>BARKING HEADS & MEOWING HEADS</strong></a>
                    </div>                     
                    <div class="menu-item1">
                        <a href="/savic/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" /><strong>SAVIC</strong></a>
                    </div> 
                    <div class="menu-item1">
                        <a href="/yow-up/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" /><strong>YOW UP</strong></a>
                    </div> 
                    <div class="menu-item1">
                        <a href="/dolina-piper-rafi/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" /><strong>DOLINA-PIPER-RAFI
                        </strong></a>
                    </div> 
                    <div class="menu-item1">
                        <a href="/egeo-pet-food/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" /><strong>EGEO PET FOOD
                        </strong></a>
                    </div>
                    <div class="menu-item1">
                        <a href="/inaba/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" /><strong>INABA
                        </strong></a>
                    </div>
                    <div class="menu-item1">
                        <a href="/reflex-enjoy-proline/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" /><strong>REFLEX-ENJOY-PROLINE
                        </strong></a>
                    </div>
                    <div class="menu-item1">
                        <a href="/natural-trainer/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" /><strong>NATURAL TRAINER
                        </strong></a>
                    </div>
                    <div class="menu-item1">
                        <a href="/perfect-care/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" /><strong>PERFECT CARE</strong></a>
                    </div>

                </div>
                <div class="menu-col4 en">
                    
                </div>
            </div>
            </div>
        </transition>-->
    </div>
</template>


<script>

export default ({
    name: 'sidebar-right',
    props: ['title', 'items','itemsen','titlen'],
    data () {
        return{
            isOpen: false,
            secondTime: true
        }
    }
})

</script>

<style>

.side-cont{
    position: relative;
}
*{
  scrollbar-width: thin !important;
  font-family: 'Play-Regular' !important;  
}
.img-text{
    display: flex;
    gap:15px !important;
    padding-left: 40px;
    margin-bottom: 25px;
}
.menu-col{
    width: 65% !important;
    padding-top: 50px !important;
    padding-left: 240px !important;
}

.menu-col1{
    width: 35% !important;
    padding-right: 240px !important;
    border-left: 1px solid #e5e5e5;
    padding-top: 50px;
    padding-bottom: 25px;
}
.menu-item1{
    display: flex;
}

    .dropdown{
        text-align: center;
    }
    .button-dropdown {
        font-size: 40px;
        text-decoration: none;
        color:#222 !important;
        display: inline-block;
        position: relative;
    }
 
 .button-dropdown:after {
    content: '';
    position: absolute;
    width: 100%;
    transform: scaleX(0);
    height: 1px;
    bottom: 0;
    left: 0;
    background-color: #222;
    transform-origin: bottom right;
    transition: transform 0.25s ease-out;
}

.button-dropdown:hover:after{
  transform: scaleX(1);
  transform-origin: bottom left;
}
    .button-dropdown svg{
        margin-left: 10px;
        width:15px !important;
        filter:none !important;
    }
    .menu-item svg{
        width:10px !important;
        
    }
    .menu-btn{
        padding-left:10px !important;
    }
    .sidebar-drop img{
        width: 120px !important;
        height: 90px !important;
        object-fit: cover;
        border-radius: 5px !important;
    }
    .sidebar-drop{
        border-top: 1px solid #e7e7e7;
        background-color: #fffdfd;
        width:100% !important;
        z-index: 99;
        box-shadow: 1px 3px 3px rgb(0 0 0 / 21%);
        margin-left: auto;
        margin-right: auto;
        text-align: left;
        padding: 0px 0;
        margin-top: 20px;
        overflow: scroll;
        display: flex;
        overflow-x: hidden;
        scrollbar-width: thin !important;
    }
 

   
    .sidebar-drop .menu-item1 {
        font-size: 20px;
        padding: 9px 40px;
        font-weight: 600;
    }

    .sidebar-drop .menu-item1 a{
       text-align: left;
       text-decoration: none;
       color:#222;
       display: inline-block;
       padding-bottom:5px;
       position: relative;
    }
    .title-text a{
        text-decoration: none;
        color:#222 !important
    }
    .title-text a:hover{
        color:#719452 !important
    }
    /* .sidebar-drop .menu-item1 a:after {
        content: '';
        position: absolute;
        width: 100%;
        transform: scaleX(0);
        height: 1px;
        bottom: 0;
        left: 0;
        background-color: #222;
        transform-origin: bottom right;
        transition: transform 0.25s ease-out;
    }*/

    .sidebar-drop .menu-item1 a:hover:after{
        transform: scaleX(1);
        transform-origin: bottom left;
    }
    .sidebar-drop.menu-item1:hover{
        background-color: #fff;
        color:#222;     
    }
    .sidebar-drop .menu-item1 a:hover{
        color:#719452 !important
    }
    .slide-up-enter-active,
    .slide-up-leave-active {
        transition: all 0.4s ease-out;
    }

.slide-up-enter,.slide-up-leave-to{
  opacity: 0;
  transform: translateY(30px);
}
.sidebar-drop .myico {
    width: 33px !important;
    height: auto !important;
    min-width: 33px !important;
    background: #1c6aa3;
    border-radius: 50% !important;
    padding: 4px;
    box-shadow: -2px 2px #91bee0 !important;
}
.menu-item2 a{
    display: flex !important;
    align-items: center !important;
    gap:10px !important
}
/*.menu-item2.menu-item2 img{
    filter: invert(10%) sepia(75%) saturate(1016%) hue-rotate(185deg) brightness(98%) contrast(93%) !important;
}*/

.rot{
    transform: rotate(345deg);
}

/*
.slide-up-leave-to {
  opacity: 0;
  transform: translateY(-30px);
}*/

@media only screen and (max-width: 767px) {
    nav .menu-item1 .sidebar{
        width:100% !important;
    }
}

</style>